// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c12c198","453":"6f4ca38c","455":"8959d10f","977":"0a109157"}[chunkId] + ".chunk.js";
};